// src/pages/Dashboard.tsx
import React from "react";
import { Typography, Box } from "@mui/material";

export default function Dashboard() {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4">Dashboard</Typography>
      <Typography variant="body1">This is the Dashboard page.</Typography>
    </Box>
  );
}
